export const GUEST_SESSION_STORE_KEY = 'viverse_guest_session_store'

export type GuestSessionStore = {
  isOver18?: boolean
}
